const initAttr = "_billing_pricing_initialized"

class BillingPricingComponent {
  static init(pricing) {
    const elements = pricing.element.querySelectorAll(this.selector)

    return Array.from(elements).map(element => new this(element, pricing))
  }

  constructor(element, pricing) {
    this.element = element
    this.pricing = pricing

    if (!this.element[initAttr]) {
      this.init()
    }
  }

  initialized() {
    this.element[initAttr] = true
  }

  valid() {
    return this.element[initAttr] && this.selected
  }
}

export default BillingPricingComponent
